import {
  ApiBusinessCardImage,
  ApiCompanyAddress,
  ApiCompanyDetails,
  ApiContactDetails,
  ApiMessages,
  ApiPersonalDetails,
  ApiSocialMedia,
  BusinessCardImage,
  CompanyAddress,
  CompanyDetails,
  ContactDetails,
  Messages,
  PersonalDetails,
  SocialMedia,
} from '../interfaces/commons.interface';

export function transformPersonalDetails(apiPersonalDetails?: ApiPersonalDetails): PersonalDetails {
  return {
    salutation: apiPersonalDetails?.salutation,
    title: apiPersonalDetails?.title,
    first_name: apiPersonalDetails?.first_name,
    last_name: apiPersonalDetails?.last_name,
    area_of_interest: apiPersonalDetails?.area_of_interest,
    ...transformBusinessCardImage(apiPersonalDetails?.profile_image),
  };
}

export function transformApiPersonalDetails(personalDetails?: PersonalDetails): ApiPersonalDetails | undefined {
  return personalDetails
    ? {
        salutation: personalDetails.salutation,
        title: personalDetails.title,
        area_of_interest: personalDetails.area_of_interest !== '' ? personalDetails.area_of_interest : undefined,
      }
    : undefined;
}

export function transformCompanyAddress(apiCompanyAddress?: ApiCompanyAddress): CompanyAddress {
  return {
    street_address: apiCompanyAddress?.street_address,
    postal_code: apiCompanyAddress?.postal_code,
    locality: apiCompanyAddress?.locality,
    country_name: apiCompanyAddress?.country_name,
    region: apiCompanyAddress?.region,
  };
}

export function transformApiCompanyAddress(companyAddress?: CompanyAddress): ApiCompanyAddress | undefined {
  return companyAddress
    ? {
        street_address: companyAddress.street_address,
        postal_code: companyAddress.postal_code,
        locality: companyAddress.locality,
        country_name: companyAddress.country_name,
        region: companyAddress.region,
      }
    : undefined;
}

export function transformCompanyDetails(apiCompanyDetails?: ApiCompanyDetails): CompanyDetails {
  return {
    position: apiCompanyDetails?.title,
    company_name: apiCompanyDetails?.name,
    website: apiCompanyDetails?.website,
    employee_count: apiCompanyDetails?.employee_count,
    ...transformCompanyAddress(apiCompanyDetails?.address),
  };
}

export function transformApiCompanyDetails(companyDetails?: CompanyDetails): ApiCompanyDetails | undefined {
  return companyDetails
    ? {
        title: companyDetails.position,
        name: companyDetails.company_name,
        website: companyDetails.website,
        employee_count: companyDetails.employee_count !== '' ? companyDetails.employee_count : undefined,
        address: transformApiCompanyAddress(companyDetails),
      }
    : undefined;
}

export function transformBusinessCardImage(apiBusinessCardImage?: ApiBusinessCardImage): BusinessCardImage {
  return {
    profile_image_uuid: apiBusinessCardImage?.uuid,
    profile_image_url: apiBusinessCardImage?.url,
    canto_id: apiBusinessCardImage?.canto_id,
  };
}

export function transformSocialMedia(apiSocialMedia?: ApiSocialMedia): SocialMedia {
  return {
    linkedin: apiSocialMedia?.linkedin,
    xing: apiSocialMedia?.xing,
    facebook: apiSocialMedia?.facebook,
  };
}

export function transformApiSocialMedia(socialMedia?: SocialMedia): ApiSocialMedia | undefined {
  return socialMedia
    ? {
        linkedin: socialMedia.linkedin,
        xing: socialMedia.xing,
        facebook: socialMedia.facebook,
      }
    : undefined;
}

export function transformContactDetails(apiContactDetails?: ApiContactDetails): ContactDetails {
  return {
    email: apiContactDetails?.email,
    phone_number: apiContactDetails?.phone_number,
    mobile_number: apiContactDetails?.mobile_number,
    additional_email: apiContactDetails?.additional_email,
    ...transformSocialMedia(apiContactDetails?.social_media),
  };
}

export function transformApiContactDetails(contactDetails?: ContactDetails): ApiContactDetails | undefined {
  return contactDetails
    ? {
        phone_number: contactDetails.phone_number,
        mobile_number: contactDetails.mobile_number,
        additional_email: contactDetails.additional_email,
        social_media: transformApiSocialMedia(contactDetails),
      }
    : undefined;
}

export function transformMessages(apiMessages?: ApiMessages): Messages {
  return {
    business_card_message: apiMessages?.business_card_message,
  };
}

export function transformApiMessages(messages?: Messages): ApiMessages {
  return {
    business_card_message: messages?.business_card_message,
  };
}
